// Búsqueda práctica: sin distinguir mayúsculas ni tildes, y por PALABRAS
// (cada palabra del texto buscado debe aparecer en algún campo, en cualquier orden).
export const norm = (s) => String(s || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, ''); // quita tildes/diacríticos

export const coincide = (query, ...campos) => {
  const hay = norm(campos.join(' '));
  return norm(query).split(/\s+/).filter(Boolean).every((t) => hay.includes(t));
};
